/**
 * Live mm:ss elapsed counter for a Processing import card (B-452). Ticks every
 * second so a long background import never reads as frozen. Moved out of
 * V2DashboardPage (god-file ratchet) when PRP-MCP-5 added the chat estimates.
 */
import { useEffect, useState } from 'react';

export default function ElapsedTimer({ startedAt }: { startedAt: number }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);
  const total = Math.max(0, Math.floor((now - startedAt) / 1000));
  const mm = Math.floor(total / 60);
  const ss = String(total % 60).padStart(2, '0');
  return (
    <span className="font-[var(--font-mono)] text-[11px] tabular-nums text-[var(--tx-faint)]">
      {mm}:{ss}
    </span>
  );
}
